var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5861 15.8618H0.413811C0.185296 15.8618 0 15.6765 0 15.448V0.551506C0 0.322991 0.185296 0.137695 0.413811 0.137695H23.5861C23.8147 0.137695 24 0.322991 24 0.551506V15.448C23.9999 15.6765 23.8146 15.8618 23.5861 15.8618Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 0.551506C23.9999 0.322991 23.8146 0.137695 23.5861 0.137695H21.7348L14.0689 5.16019V0.137695H9.93095V5.16019L2.26508 0.137695H0.413811C0.185296 0.137695 0 0.322991 0 0.551506V1.6217L6.57696 5.93077H0V10.0687H6.57696L0 14.3778V15.448C0 15.6765 0.185296 15.8618 0.413811 15.8618H2.26513L9.93104 10.8393V15.8618H14.069V10.8393L21.7349 15.8618H23.5862C23.8147 15.8618 24 15.6765 24 15.448V14.3778L17.423 10.0687H23.9999V5.93081H17.4229L23.9999 1.6217V0.551506Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 6.75839H13.2413V0.137695H10.7586V6.75839H0V9.24111H10.7586V15.8618H13.2413V9.24111H23.9999V6.75839Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38815 10.0684L0.0117188 15.5057C0.0410155 15.7055 0.20578 15.8615 0.413764 15.8615H0.983715L9.90821 10.0684H8.38815V10.0684V10.0684Z",
    fill: "#FF4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2369 10.0684H14.7168L23.6283 15.8529C23.836 15.8308 23.9999 15.6612 23.9999 15.4476V15.1074L16.2369 10.0684Z",
    fill: "#FF4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.00798L7.58336 5.93049H9.10342L0.241077 0.177734C0.0995152 0.2435 0 0.384827 0 0.551186V1.00798Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 5.93077L23.9855 0.480303C23.9506 0.287085 23.7893 0.137695 23.586 0.137695H22.9932L14.0688 5.93077H15.5889Z",
    fill: "#FF4B55"
  })));
};
export default SvgFlagEn;